import { collabStateManager } from '@databases/collab-state-manager';

import {
  AiFieldCellRequestCoordinator,
  type PendingAiFieldCellRequest
} from './ai-field-cell-request-coordinator.ts';
import { waitForAiFieldRunIdle } from './wait-for-ai-field-run-idle.ts';
import { waitForDatabaseStreamIdle } from './wait-for-database-stream-idle.ts';

const publishedContentIds = new Set<string>();

const publishPendingRequests = (
  pendingRequests: readonly PendingAiFieldCellRequest[]
): void => {
  const requestsByContentId = new Map<string, PendingAiFieldCellRequest[]>();
  for (const request of pendingRequests) {
    const requests = requestsByContentId.get(request.target.contentId) ?? [];
    requests.push(request);
    requestsByContentId.set(request.target.contentId, requests);
  }

  const contentIds = new Set([...publishedContentIds, ...requestsByContentId.keys()]);
  for (const contentId of contentIds) {
    const manager = collabStateManager.getCollabManager(contentId);
    const requests = requestsByContentId.get(contentId) ?? [];
    manager?.updateAiFieldCellRequests(
      requests.length === 0
        ? undefined
        : {
            protocolVersion: 1,
            requests: requests.map(({ target, status }) => ({
              aiFieldType: target.aiFieldType,
              fieldId: target.fieldId,
              entryId: target.entryId,
              status
            }))
          }
    );
  }

  publishedContentIds.clear();
  for (const contentId of requestsByContentId.keys()) {
    publishedContentIds.add(contentId);
  }
};

export const aiFieldCellRequestCoordinator = new AiFieldCellRequestCoordinator(
  async (target) => {
    await waitForDatabaseStreamIdle();
    await waitForAiFieldRunIdle(target);
  },
  publishPendingRequests
);
